import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAuth from './useAuth';
import ComponentLoader from '../../Shared/Sidebar/ComponentLoader';

/**
 * ProtectedRoute - Basic authentication guard
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({
  component: Component,
  layout: Layout,
  isAuthenticated: routePermission,
  redirectTo = '/Unauthorized',
  ...rest
}) => {
  const { isAuthenticated, loading } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return <ComponentLoader />;
        }

        if (!isAuthenticated) {
          return <Redirect to="/" />;
        }
        if (typeof routePermission !== 'undefined' && !routePermission) {
          return <Redirect to={redirectTo} />;
        }

        return Layout ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default ProtectedRoute;